export default __webpack_public_path__ + "img/banner.df52edc8.png";